import { ArrowLeft } from '@phosphor-icons/react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import AuthLayout from './AuthLayout'
import DownloadApp from './DownloadApp'

const AuthSuccess = () => {
  const { t } = useTranslation(['auth', 'common'])
  const navigate = useNavigate()

  return (
    <AuthLayout hideLogo>
      <div className="auth__success">
        <button type="button" className="auth__back-button" onClick={() => navigate('/login')}>
          <ArrowLeft />
          {t('common:actions.back')}
        </button>
        <DownloadApp content={t('auth:authSuccess.description')} />
      </div>
    </AuthLayout>
  )
}

export default AuthSuccess
